import { render, staticRenderFns } from "./GoodsImage.vue?vue&type=template&id=623accf3&scoped=true&"
import script from "./GoodsImage.vue?vue&type=script&lang=js&"
export * from "./GoodsImage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsImage.vue?vue&type=style&index=0&id=623accf3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623accf3",
  null
  
)

export default component.exports